import React from "react";
import { NavLink } from "react-router-dom";
import "./MiniCart.scss";
import { useCart } from "../../shared/CartContext";

export default function MiniCart({ open, onClose }) {
  const { items, removeFromCart, updateQty, totalItems, totalPrice } = useCart();

  const formatPrice = (num) =>
    num.toLocaleString("sr-RS") + " RSD";

  return (
    <>
      {open && <div className="mini-cart__backdrop" onClick={onClose} />}
      <div className={`mini-cart ${open ? "mini-cart--open" : ""}`}>
        <div className="mini-cart__header">
          <h3 className="mini-cart__title">Korpa ({totalItems})</h3>
          <button className="mini-cart__close" onClick={onClose} aria-label="Zatvori">✕</button>
        </div>

        <div className="mini-cart__body">
          {items.length === 0 ? (
            <div className="mini-cart__empty">
              <span className="mini-cart__empty-icon">🛍</span>
              <p>Korpa je prazna.</p>
              <NavLink to="/prodavnica" className="mini-cart__shop-link" onClick={onClose}>
                Pogledaj ikone →
              </NavLink>
            </div>
          ) : (
            <ul className="mini-cart__list">
              {items.map((item) => (
                <li key={item.slug} className="mini-cart__item">
                  <div className="mini-cart__item-img">
                    <img src={item.pic} alt={item.title} />
                  </div>
                  <div className="mini-cart__item-info">
                    <p className="mini-cart__item-title">{item.title}</p>
                    <p className="mini-cart__item-meta">{item.dimenzije}</p>
                    <p className="mini-cart__item-price">{item.cena}</p>
                    <div className="mini-cart__item-qty">
                      <button onClick={() => updateQty(item.slug, item.kolicina - 1)}>−</button>
                      <span>{item.kolicina}</span>
                      <button onClick={() => updateQty(item.slug, item.kolicina + 1)}>+</button>
                    </div>
                  </div>
                  <button className="mini-cart__item-remove" onClick={() => removeFromCart(item.slug)} aria-label="Ukloni">✕</button>
                </li>
              ))}
            </ul>
          )}
        </div>

        {items.length > 0 && (
          <div className="mini-cart__footer">
            <div className="mini-cart__total">
              <span>Ukupno:</span>
              <strong>{formatPrice(totalPrice)}</strong>
            </div>
            <NavLink to="/korpa" className="mini-cart__checkout-btn" onClick={onClose}>
              Pregledaj korpu
            </NavLink>
          </div>
        )}
      </div>
    </>
  );
}
